import getLocaleCookie from './get-locale-cookie';
import setLocaleCookie from './set-locale-cookie';

export { getLocaleCookie, setLocaleCookie };
